import { Line, Text } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useRef } from "react";
import { BEAM_LEFT_OFFSET,  SERIF} from "../../constants";
import { useSettings } from "../../hooks/useSettings";
import { useShelvingStore, useStoreRoom } from "../../store";

export const TotalDimensionRoomVertical = () => {
    const groupRef = useRef<any>(null);
    const ref = useRef<any>(null);
    const textRef = useRef<any>(null);

    useFrame(() => {
        const currentShelving = useShelvingStore.getState().getCurrentShelving();

        const roomHeight = useStoreRoom.getState().height;
        const roomLength = useStoreRoom.getState().length;
        const roomDepth = useStoreRoom.getState().depth;

        const sideIndent = currentShelving.sideIndent;

        const width = ["left", "right"].includes(currentShelving.name) ? roomDepth : roomLength;
        if (groupRef.current) {
            groupRef.current.scale.y = roomHeight / 1000;
            groupRef.current.position.x =
                sideIndent < 500 ? (width - BEAM_LEFT_OFFSET * 3) / 2000 : -(width - BEAM_LEFT_OFFSET * 3) / 2000;
            groupRef.current.position.y = 0;
            groupRef.current.position.z = 0.1;

            textRef.current.position.x =
                sideIndent < 500 ? (width - BEAM_LEFT_OFFSET * 5) / 2000 : -(width - BEAM_LEFT_OFFSET * 5) / 2000;
            textRef.current.position.y = roomHeight / 2000;
            textRef.current.rotation.z = Math.PI / 2;
            textRef.current.text = roomHeight;
            textRef.current.position.z = 0.1;
        }
    });
    
    const { isVisibleSizes } = useSettings();
    if (!isVisibleSizes) {
        return null;
    }

    return (
        <group>
            <group ref={groupRef}>
                <Line
                    points={[
                        [-SERIF, 0, 0],
                        [SERIF, 0, 0],
                    ]}
                    lineWidth={1}
                    color="white"
                />
                <Line
                    points={[
                        [-SERIF, 1, 0],
                        [SERIF, 1, 0],
                    ]}
                    lineWidth={1}
                    color="white"
                />
                <Line
                    ref={ref}
                    points={[
                        [0, 0, 0],
                        [0, 1, 0],
                    ]}
                    lineWidth={0.5}
                    color="white"
                />
            </group>
            <Text ref={textRef} color="white" anchorX="center" anchorY="middle">
                {" "}
            </Text>
        </group>
    );
};
